export const SET_NAV_VALUES = "SET_NAV_VALUES"